export default __webpack_public_path__ + "public/assets/images/510649d908a1185e19d898177fb03a47.svg";